export const COUNTRY_CLASS: Record<string, string> = {
  en: "us",
  du: "de",
  es: "es",
  fr: "fr",
  pt: "pt",
  cn: "cn",
  ae: "ae",
};

export const LANGUAGE =[
  {
  languageParameter: "en",
  languageName: "English",
  languageIconClassName: "us",
  subTitle:"US"
  },
  {
  languageParameter: "du",
  languageName: "Deutsch",
  languageIconClassName: "de",
  },
  {
  languageParameter: "es",
  languageName: "Español",
  languageIconClassName: "es",
  },
  {
  languageParameter: "fr",
  languageName: "Français",
  languageIconClassName: "fr",
  },
  {
  languageParameter: "pt",
  languageName: "Português",
  languageIconClassName: "pt",
  subTitle:"BR"
  },
  {
  languageParameter: "cn",
  languageName: "简体中文",
  languageIconClassName: "cn",
  },
  {
  languageParameter: "ae",
  languageName: "لعربي",
  languageIconClassName: "ae",
  subTitle:"ae"
  },
 ];
